export const educationTypeIds = {
  EXTRAMURAL: 1,
  FAMILY: 2,
  ONLINE_SCHOOL: 3,
}
